import React from 'react';
import Eipluscoins from './Eipluscoins';

function App() {
  return <Eipluscoins />;
}

export default App;
